<!--企业注销-->
<!--wj-->
<template>
    <div class="EnterCancellat">
        <detail-title></detail-title>
        <el-row class="Plan-heard" style="padding-top:5rem;">
            <el-col :span="24" class="Plan-col">
                <img src="@/assets/image/default-qyzx.jpg" />
            </el-col>
        </el-row>
        <el-row class="Plan-body" style="margin-top:13%;">
            <el-col :span="24" class="Plan-col">
                <p class="BE-title"><strong>企业注销预约</strong></p>
                <el-form ref="form" :model="form" label-width="0px" :rules="rules" class="BE-form">
                    <el-form-item>
                        <el-input v-model="form.address" placeholder="办理城市"></el-input>
                    </el-form-item>
                    <el-form-item prop="phone">
                        <el-input v-model.number="form.phone" :maxlength='11' placeholder="请输入手机号"></el-input>
                    </el-form-item>
                    <el-form-item style="text-align: center;">
                       <button type="button" :class="showBtn?'EB-button':'EC-button'" :disabled="showBtn" @click="zixunBtn('form')">立即预约</button>
                    </el-form-item>
                    <el-carousel height="22px" direction="vertical" :autoplay="true" indicator-position="none" :interval="3000">
                      <el-carousel-item v-for="item in list.data" :key="item.esdmId">
                          <p  class="BE-carousel">
                            <img src="@/assets/image/ico-new.svg">
                            <span>{{item.esdmTime}}</span>分钟前，
                            <span>{{item.esdmTel}}</span>{{item.esdmContent}}
                          </p>
                      </el-carousel-item>
                  </el-carousel>
                  <p class="BE-count" v-if="list.count">累计办理<span>{{list.count}}</span>件</p>
                </el-form>
            </el-col>
        </el-row>
        <div v-if="espmDesc" class="BE-html" v-html="espmDesc"></div>
        <el-row class="BE-footer" :gutter="20">
            <el-col :span="12">
                <div class="BE-border"><a :href="'tel:' + tell"><img src="@/assets/image/ico-tel.svg">{{tell}}</a></div>
            </el-col>
            <el-col :span="12">
                <div class="BE-border" @click="OpenImg()"><img src="@/assets/image/ico-wx.svg">关注微信公众号</div>
            </el-col>
        </el-row>
        <div class="es-shaow" v-if="showZX">
            <div class="es-shaow-in">
                <div class="es-shaow-head">
                    <el-row>
                        <el-col :span="24" style="text-align:right;"><img src="@/assets/image/interact-btn-close.png" @click="Close()"></el-col>
                    </el-row>
                </div>
                <div class="eb-content">
                   <img :src="Img">
                </div>
                <div class="es-footer">长按识别图中二维码</div>
            </div>
        </div>
        <!-- 立即咨询 -->
        <div class="es-shaow" v-if="showTip">
            <div class="es-shaow-in">
                <div class="es-shaow-head">
                    <el-row>
                        <el-col :span="24" style="text-align:right;"><img src="@/assets/image/interact-btn-close.png" @click="CloseTip()"></el-col>
                    </el-row>
                </div>
                <div class="es-content">
                    <p>{{tip}}</p>
                </div>
                <div class="eb-footer" @click="CloseTip()">我知道了</div>
            </div>
        </div>
        <share-wechat></share-wechat>
    </div>
</template>
<script>
import DetailTitle from "@/components/DetailTitle";
import Axios from 'axios';
import { eventBus } from '@/assets/js/eventBus';
import ShareWechat from "@/components/ShareWechat";
import MP from "@/assets/js/map";
export default {
  data() {
    var phones = (rule, value, callback) => {
      if (!value) {
        this.showBtn = false;
        return callback(new Error('电话不能为空'));
      }else{
        callback();
      }
    };
    return {
      list:[],
      form: {
        address: "",
        phone: "",
      },
      rules:{
          phone: [
            { validator: phones, trigger: 'blur' },
          ],
      },
      showZX: false,
      tell: "400-829-6689",
      Img: require("@/assets/image/gzh.jpg"),
      espmDesc:'',
      showTip:false,
      tip:'',
      showBtn:false,
    };
  },
  mounted() {
    const that = this;
    var locations = location.href;
    that.getList();
    
    //获取地址
    MP.init().then(BMap => {
      var p;
      var myP = new BMap.LocalCity(); //百度地图
      myP.get(myFun);
      function myFun(result) {
        p = result.center;
        var myCity = new BMap.Geocoder();
        myCity.getLocation(p, function(v) {
           that.form.address = v.addressComponents.city;
        });
      }
    });
    var shareList = {
        title:'企业注销',
        content:'绿色通道，加急办理',
    };
    eventBus.$emit("shareList",shareList);
  },
  methods: {
    //获取消息和详情
    getList(){
      const that = this;
      var param ={
        condition:'企业注销'
      }
      Axios.post(that.$store.state.APIURLS + "Esdm/findByPage",param).then(function(res) {
        if(res.data.code == 200){
          res.data.data.data.forEach(e => {
              var reg = /^(\d{3})\d*(\d{4})$/;
              var str2 = e.esdmTel.replace(reg,'$1****$2');
              e.esdmTel = str2;
          });
          that.list = res.data.data;
        }
      })
      Axios.get(that.$store.state.APIURLS + "Espm/findByType?espmType=企业注销").then(function(res) {
        if(res.data.code == 200){
          that.espmDesc = res.data.data.espmAppContent;
        }
      })
      Axios.get(that.$store.state.APIURLS +"Consult/searchTel").then(function(res) {
          if(res.data.code==200){
            if(!res.data.data){
                that.tell = '400-829-6689';
            }else{
                that.tell = res.data.data;
            }
        }else{
            that.tell = '400-829-6689';
        }
      })
    },
    //立即咨询
    zixunBtn(formName) {
      const that = this;
      that.showBtn = true;
      this.$refs[formName].validate((valid) => {
        if (valid) {
            const reg = /^[0-9]{1,}$/;
            var num = '';
            if(!reg.test(that.form.phone)){
              that.showBtn = false;
              that.$toast({ message: '请输入正确的手机号',type: "success", position: "bottom",duration: "2000"});
              return false;
            }else{
              num = that.form.phone;
            }
            var param ={
              escmType:'企业注销',
              escmCity:that.form.address,
              escmTel:num,
              escmActive:'未沟通',
            }
            setTimeout(() => {
              that.showBtn = false;
            },3000)
            Axios.post(that.$store.state.APIURLS + "Escm/add",param).then(function(res) {
              that.showTip = true;
              that.tip = res.data.msg;
            })
        } else {
          that.showBtn = false;
          return false;
        }
      });
    },
    //OpenImg打开弹窗
    OpenImg() {
      const that = this;
      that.showZX = true;
    },
    //关闭弹窗
    Close() {
      const that = this;
      that.showZX = false;
    },
    //关闭提示弹窗
    CloseTip(){
      const that = this;
      that.showTip = false;
    },
  },
  components: {
    DetailTitle,
    ShareWechat
  },
};
</script>
